export default __webpack_public_path__ + "static/media/340db581-50b2-4783-8f40-db42ea764bda.4382af08.ttf";